/* global axios */
import ApiClient from '../ApiClient';

class InboxPilotAssistant extends ApiClient {
  constructor() {
    // 继承自 inboxes 资源，这样 this.url 会是 /api/v1/accounts/:accountId/inboxes
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/pilot_assistant`);
  }

  update(inboxId, { assistantId, routingMode }) {
    return axios.put(`${this.url}/${inboxId}/pilot_assistant`, {
      assistant_id: assistantId,
      routing_mode: routingMode,
    });
  }

  disconnect(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/pilot_assistant`);
  }
}

export default new InboxPilotAssistant();
